exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.home[data-v-efe030de]{width:100%\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/financeiro/Home.vue"],"names":[],"mappings":";AAgBA,uBACE,UACF;CAAC","file":"Home.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.home {\n  width: 100%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-efe030de","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/financeiro/Home.vue
// module id = AqFa
// module chunks = 11